<template>
    <div class="disclaimer email-verification">
       
        <div v-if="agreement.status != 'under_review'" class="disclaimer-body flex row align-center gap-10 mb-5 w-full justify-between">
            <div v-if="agreement.status == 'rejected'">
                <div class="req-warning text-left"> <img src="@/assets/warning_.svg">
                    Previously uploaded agreement was rejected by our team. 
                    
                </div> 
                 <div class="disclaimer-text">
                    Please download, review and sign the agreement again:
                </div>
                <div class="disclaimer-text" style="color: red">
                    Rejection Reason: {{ agreement.rejection_reason }}
                </div>
            </div>
            <div v-else class="flex align-start gap-5px mb-5 column ">
                <div class="req-warning text-left"> <img src="@/assets/warning_.svg">
                    <text v-if="missingUserInfoFields.length == 0">
                        <text v-if="!agreement.file_id">
                            Please download, review and sign the agreement:
                        </text>
                        <text v-else>
                            Sign and upload the agreement:
                        </text>
                    </text> 
                    <text v-else>
                        Fill in the dashboard information to see agreement
                    </text>
                </div> 
                <div class="disclaimer-text">
                    <text v-if="missingUserInfoFields.length == 0">
                        Agreement needs to be signed to be able to generate reports and use the platform effectively.
                    </text>
                    <text v-else>
                        Some of the provided information will be included in the agreement. 
                    </text>
                </div>
            </div>
            <div class="">
                <button v-if="agreement.file_id"
                    class="verify-button w-content"
                    @click="() => uploaderOpen = true"
                >Upload
                    <img src="@/assets/arrow-opener.svg" style="margin-left: 10px;">
                </button>
                <button
                    :disabled="missingUserInfoFields.length > 0"
                    class="verify-button w-content"
                    @click="openAgreement()"
                >Download 
                    <img src="@/assets/arrow-opener.svg" style="margin-left: 10px;">
                </button>
            </div>
            
        </div>
        <div v-else class="disclaimer-body flex row align-center gap-10 mb-5 w-full justify-between">
            <div class="flex align-start gap-5px mb-5 column ">
                <div class="req-warning text-left"> 
                    <img src="@/assets/sand-clock.svg" class="wait-logo">
                    Agreement submited
                </div> 
                <div class="disclaimer-text">
                    The agreement is under review, our team will look into it shortly. Once there is an update, we will notify you by email.
                </div>
            </div>
        </div>
        <PopupCover v-if="uploaderOpen" @close="() => uploaderOpen = false">
           <PopupBody @close="() => uploaderOpen = false">
                <template #header>
                    Upload Signed Agreement
                </template>
                <template #body>
                    <div class="popup-container flex column gap-10">
                        <div class="header-of-section">Attach File:</div>
                        <MultiFileUploader type=".pdf" :single=true @sendFileInfo="getFiles" class="uploadfile" />
                        <div class="flex row gap-10">
                            <button class='transparent' @click="() => { uploaderOpen = false, selectedFile = false; }">Cancel</button>
                            <button class='button' :disabled="!selectedFile" @click="uploadAgreement()">Upload</button>
                        </div>
                    </div>
                </template>
           </PopupBody>
        </PopupCover>
    </div>
</template>


<script setup>
    import { computed, ref } from 'vue';
    import { useStore } from 'vuex';
    import API from '../api/index.js'
    import PopupCover from '@/components/PopupCover.vue';
    import PopupBody from '@/components/PopupBody.vue';
    import MultiFileUploader from '@/components/MultifileUploader.vue';

    const missingUserInfoFields = computed(() => store.getters.missingUserInfoFields)
    const uploaderOpen = ref(false);
    const store = useStore();
    const agreement = computed(() => store.state.agreements ? store.state.agreements.find(el => el.type == 'agreement'): null);
    const selectedFile = ref(false);
    const isSent = ref(false);
    const userInformation = computed(() => store.state.userInformation)
    
    async function openAgreement() {
        await API.downloadAgreementFile(agreement.value.id, `${userInformation.value.rentity_branch} Agreement.pdf`, '', true);
    }

    function getFiles(files) {
        selectedFile.value = files[0];
    }
    async function uploadAgreement(){
        if (!selectedFile.value || isSent.value) {
            return;
        }
        try {
            isSent.value = true
            const result = await API.uploadAgreementUser(selectedFile.value);
            if (result.user_file_id) {
                selectedFile.value = false;
                store.dispatch('addNotification', { type: 'success', text: 'Agreement uploaded successfully. You will receive email notification once it gets reviewed' });
                uploaderOpen.value = false;
                
                const storeAgreement = store.state.agreements.find(el => el.type == 'agreement');
                if (storeAgreement) {
                    storeAgreement.status = 'under_review';
                }
            }
        } catch (error){

        } finally {
            isSent.value = false
        }
    }

</script>

<style lang="scss" scoped>
    .verify-button {
        width: 160px;
        min-width: 120px;
        margin-left: 20px;
        height: 35px;
        margin-top: 10px;
    }

.disclaimer {
  box-shadow: 0px 0px 1.5px 0px #949494;
  padding: 20px;
  width: 100%;
  max-width: 1350px;
  border-radius: 10px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  background-color: white;
  // background-color: #FEF4F5;
}
.req-warning {
  color: black;

  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  img {
      margin-right: 20px;
  }
}

.warning-point {
  padding-left: 40px;
  font-size: 14px;
  font-weight: 500;
  margin-left: 25px;
  position: relative;
  &::before {
      content: '';
      position: absolute;
      left: 25px;
      top: 8px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #BB3530;
  }
}
.disclaimer-text {
  padding-top: 3px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 47px;
  text-align: left;
}
.disclaimer-body {
    background-color: #FAF7F6;
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
}
.terms-page {
    max-width: 90vw;
    overflow-y: auto;
    // font-size: 1rem;
    padding: 0;
}
.header-of-section {
    color: black;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
}
.wait-logo[class] {
    width: 30px;
    margin-right: 15px;
}
</style>